export const WHITE_IN_LIGHT_MODE = "light-dark(#fff, #000)";
export const BLACK_IN_LIGHT_MODE = "light-dark(#000, #fff)";
//# sourceMappingURL=customColors.js.map